export const encodeQuery = query => query && query.replace(/#/g, '~num~').replace(/\s/g, '-');
export const decodeQuery = query => query && query.replace(/~num~/g, '#').replace(/-/g, ' ');
export const decodeSpaces = query => query && query.replace(/-/g, ' ');
